/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import * as React from 'react';
import { Pagination as PaginationKit, CompactPagination as CompactPaginationKit, SIZE_XXL } from '@veeam/components';
import { observer } from 'mobx-react-lite';

// eslint-disable-next-line import/no-cycle
import { useGridApi } from '../../hooks';

import type { GridStore } from '../../stores/grid-store/grid-store';

export const Pagination: React.FC = observer(() => {
    const store = useGridApi() as GridStore<unknown, unknown, unknown>;
    const isCompact = store.paginationStore.useCompactPaginationWithCurrentPage || store.paginationStore.useCompactPagination;

    if (!store.paginationStore.withPagination || store.pagination.fullPages <= 1) return;

    if (isCompact) {
        return (
            <CompactPaginationKit
                currentPage={store.paginationStore.useCompactPaginationWithCurrentPage ? store.pagination.activePage : undefined}
                disabled={store.loading}
                onPrevClick={() => store.goToPage(store.pagination.activePage - 1)}
                onNextClick={() => store.goToPage(store.pagination.activePage + 1)}
                hasNext={store.pagination.activePage !== store.pagination.fullPages}
                hasPrev={store.pagination.activePage !== 1}
                style={{
                    height: SIZE_XXL,
                    alignSelf: 'center',
                    display: 'flex',
                    alignItems: 'center',
                }}
            />
        );
    }

    return (
        <PaginationKit
            activePage={store.pagination.activePage}
            lastPage={store.pagination.fullPages}
            onPageChange={store.goToPage}
            onPageClick={store.goToPage}
            disabled={store.loading}
            style={{ alignSelf: 'center' }}
        />
    );
});
